import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43609f7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "password-form" }
const _hoisted_2 = { id: "description" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t("CHANGE_PASSWORD.TITLE")), 1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("CHANGE_PASSWORD.DESCRIPTION")), 1),
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.resetPassword()), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("CHANGE_PASSWORD.NEW")) + " ", 1),
            _hoisted_4,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newPassword) = $event)),
              type: "password",
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, _ctx.newPassword]
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("CHANGE_PASSWORD.CONFIRM")) + " ", 1),
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.confirmPassword) = $event)),
              type: "password",
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, _ctx.confirmPassword]
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "btn primary",
            disabled: _ctx.invalidPasswords() || !_ctx.changePasswordButtonEnabled,
            type: "submit"
          }, _toDisplayString(_ctx.$t("PASSWORD_MODAL.SET")), 9, _hoisted_6)
        ])
      ])
    ], 32)
  ]))
}